import { fetcher } from "@/lib/fetchers";
import { IVisit } from "@/types";
import { useEffect, useState } from "react";

export const useVisitStats = ({ enabled = true } = {}) => {
    const [data, setData] = useState<IVisit | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (enabled) {
            setIsLoading(true);
            fetcher<IVisit>("/api/visits")
                .then((data) => {
                    setData(data);
                })
                .catch(() => setIsError(true))
                .finally(() => setIsLoading(false));
        }
    }, [enabled]);

    return {
        data,
        isLoading,
        isError,
    };
};
